import { useState, useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { DateValidationError, LocalizationProvider, MobileTimePicker, pickersLayoutClasses, TimeValidationError } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Input } from "reactstrap";
import dayjs, { Dayjs } from "dayjs";
import { size } from "cypress/types/lodash";


export default function TimeInput() {

    const ctx = useFormContext();
    const [time, setTime] = useState<Dayjs | null>(dayjs(new Date().setTime(new Date().getTime() + 60000)))
    const [error, setError] = useState<TimeValidationError | null>(null);

    useEffect(() => {
       ctx.setValue("departure", time?.toDate())
    }, [time])

    const errorMessage = useMemo(() => {
        switch (error) {
            case 'disablePast': {
                return 'Time selected is in the past'
            }

            default: {
                return '';
            }
        }
    }, [error]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileTimePicker 
            ampm={false} 
            minutesStep={15} 
            // disablePast 
            value={time} 
            onChange={(newTime) => setTime(newTime)} 
            onError={(newError) => setError(newError)}
            slotProps={{
                textField: {
                    helperText: errorMessage,
                    fullWidth: true,
                    size: "small",
                    sx: {
                        '.Mui-focused fieldset': {
                            borderColor: '#2e7d32 !important'
                        },
                        'fieldset': {
                            borderWidth: 2,
                            borderRadius: '15px',
                          
                        },
                        'input': {
                            textAlign:'center',
                            padding: '3px',
                            fontWeight: 'bold',
                            color: 'grey'
                        }
                    },
                },
                layout: {
                    sx: {
                        [`.${pickersLayoutClasses.contentWrapper}`]: {
                            '.MuiTimeClock-root': {
                                '.MuiClock-pin, .MuiClockPointer-root,  .Mui-selected': {
                                    backgroundColor: '#77c768'
                                },
                                '.MuiClockPointer-thumb': {
                                    border: '16px solid #77c768'
                                }
                            }
                        }
                    }
                }
            }}
            />
        </LocalizationProvider>
    )
    
}